<template>
  <div class="custom-form">
    <div class="panel panel-primary">
      <div class="panel-heading">
        <h3 class="panel-title">Customer details</h3>
      </div>
      <div class="panel-body">
        <div
          class="form-group"
          v-bind:class="{ 'has-error': errors.has('cst_Name') }"
        >
          <label for="cst_Name">Name</label>
          <input
            id="cst_Name"
            name="cst_Name"
            v-model.trim="fdata.cst_Name"
            v-validate.initial="{ required: true, max: 100 }"
            maxlength="100"
            class="form-control"
          />
          <span class="help-block">{{ errors.first("cst_Name") }}</span>
        </div>
        <div
          class="form-group"
          v-bind:class="{ 'has-error': errors.has('cst_Email') }"
        >
          <label for="cst_Email"
            >E-mail (please make sure this E-mail address is correct, audio
            files will be delivered to this E-mail)</label
          >
          <input
            id="cst_Email"
            name="cst_Email"
            v-model.trim="fdata.cst_Email"
            v-validate.initial="{ required: true, max: 100, email: true }"
            maxlength="100"
            class="form-control"
          />
          <span class="help-block">{{ errors.first("cst_Email") }}</span>
        </div>
        <div
          class="form-group"
          v-bind:class="{ 'has-error': errors.has('cst_Amount') }"
        >
          <label for="cst_Amount">Amount ($)</label>
          <input
            id="cst_Amount"
            name="cst_Amount"
            v-model.trim="fdata.cst_Amount"
            v-validate.initial="{
              required: true,
              decimal: 2,
              max: 7,
              between: [0, 99999]
            }"
            maxlength="7"
            class="form-control"
          />
          <span class="help-block">{{ errors.first("cst_Amount") }}</span>
        </div>

        <div class="btn-submit-wrapper">
          <div v-if="showAnimation" class="cc-animation">
            <span class="fa fa-spinner fa-spin fa-3x fa-fw"></span><br />
            <span class="cmi-ani-progress">order processing in progress</span>
          </div>
          <div class="cmi-admin-order-btn-wrapper">
            <button
              v-on:click="submitAdminOrder"
              v-bind:disabled="showAnimation"
              type="submit"
              class="btn btn-primary"
            >
              Submit order
            </button>
          </div>
        </div>
      </div>
    </div>

    <div>
      <modal
        name="alert-dialog-adminorder"
        @before-open="beforeOpenDialog"
        @before-close="beforeCloseDialog"
        :width="350"
        :height="'auto'"
        :clickToClose="false"
      >
        <div class="panel-primary">
          <div class="panel-heading modal-alert-heading">
            <span class="modal-alert-title">Information</span>
            <button
              @click="closeAlertDialog"
              type="button"
              class="close pull-right"
            >
              <span
                class="fa fa-times-circle modal-alert-close-button-icon"
              ></span>
            </button>
          </div>
          <div class="panel-body modal-alert-body">
            <div class="modal-alert-text-wrapper">
              <span class="fa fa-exclamation-circle modal-alert-icon"></span>
              <span class="modal-alert-text">
                {{ alertMessage }}
              </span>
            </div>
            <div class="modal-alert-footer">
              <button
                @click="closeAlertDialog"
                type="button"
                class="btn btn-primary"
              >
                OK
              </button>
            </div>
          </div>
        </div>
      </modal>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import axios from "axios";
export default {
  props: {
    baseUrl: { type: String }
  },
  data() {
    return {
      fdata: {
        cst_Name: "",
        cst_Email: "",
        cst_Amount: null,
        items: []
      },
      showAnimation: false,
      alertMessage: "",
      alertParams: null
    };
  },
  methods: {
    ...mapActions(["getToken"]),
    ...mapMutations(["resetBasket"]),
    submitAdminOrder: async function() {
      this.fdata.items = this.getBasket.map(p => p.pkey);
      const valStatus = await this.$validator.validateAll();
      if (!valStatus) {
        this.alertMessage = "Form contains validation warnings";
        this.$modal.show("alert-dialog-adminorder");
        return;
      }

      this.showAnimation = true;
      const token = await this.getToken({ vm: this });
      const config = {
        headers: {
          Authorization: `Bearer ${token}`
        }
      };
      let rData = null;
      let actionUrl = `${this.baseUrl}PlaceOrderAdmin`;
      try {
        ({ data: rData } = await axios.post(actionUrl, this.fdata, config));
      } catch (error) {
        this.showAnimation = false;
        throw error;
      }

      if (rData != 0) {
        this.alertMessage = "Form contains validation warnings";
        this.$modal.show("alert-dialog-adminorder");
        this.showAnimation = false;
        return;
      }

      this.resetFormData();
      this.alertMessage = "Your order has been submitted successfully";
      this.$modal.show("alert-dialog-adminorder", { status: 2 });
      this.showAnimation = false;
    },
    resetFormData: function() {
      Object.assign(this.fdata, {
        cst_Name: "",
        cst_Email: "",
        cst_Amount: null,
        items: []
      });
    },
    closeAlertDialog: function() {
      this.$modal.hide("alert-dialog-adminorder");
    },
    beforeOpenDialog: function({ params }) {
      if (params) {
        this.alertParams = params.status;
      }
    },
    beforeCloseDialog: function() {
      if (this.alertParams == 2) {
        this.resetBasket();
        this.alertParams = null;
      }
    }
  },
  computed: {
    ...mapGetters(["getBasket"])
  }
};
</script>
